import React from "react";

const News = () => {
  return (
    <div>
      <h4>latest news are comming soon.....</h4>
    </div>
  );
};

export default News;
